import { useEffect, useState } from 'react';
import { secondsAgo } from '../../utils/timeUtils';

type HookType = (timeStamp: number | null) => number;

const useElapsedTime: HookType = (timeStamp) => {
    const [elapsedTime, setElapsedTime] = useState(timeStamp ? secondsAgo(timeStamp) : 0);

    useEffect(
        () => {
            const interval = setInterval(() => setElapsedTime(timeStamp ? secondsAgo(timeStamp) : 0), 1000);
            return () => clearInterval(interval);
        },
        [timeStamp],
    );

    return elapsedTime;
};

export default useElapsedTime;